import { IProfileDto } from "../../dto";
import { LoginAuthType } from "../../enums";
import { IAuthMfaLoginResponse } from "./auth-mfa.models";

export interface IAccessRefreshToken {
  access_token?: string;
  refresh_token?: string;
}

/** Response from GET /auth/session/refresh-ttl-info */
export interface IRefreshTtlInfoDto {
  accessTokenExpiresInMs: number;
  expiresInMs: number;
  source: "config" | "company";
  companyId?: number;
  companyName?: string;
}

export interface IJwtPayload {
  exp: number;
  id?: number; // user id
  username?: string;
}

export const isMfaLoginResponse = (
  response: IProfileDto | IAuthMfaLoginResponse,
): response is IAuthMfaLoginResponse =>
  "mfa_required" in response && response.mfa_required === true;

// Password-based login tabs only; OAuth types (Google/SSO) use separate flows.
export type TPasswordBasedLoginAuthType =
  LoginAuthType.Username | LoginAuthType.Phone | LoginAuthType.Email;
